import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_edit",
  "use": "icon-ic_edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_edit\">\n<path d=\"M6.41421 15.9855L16.5563 5.84332L15.1421 4.42911L5 14.5713V15.9855H6.41421ZM7.24264 17.9855H3.5C3.22386 17.9855 3 17.7616 3 17.4855V13.7429L14.435 2.30779C14.8256 1.91726 15.4587 1.91726 15.8492 2.30779L18.6777 5.13621C19.0682 5.52674 19.0682 6.1599 18.6777 6.55043L7.24264 17.9855ZM3 19.9855H21V21.9855H3V19.9855Z\" fill=\"#EA1B26\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol